import axios from "axios";
import React from "react";
import { jsonHeader } from '../util/GeneralUtil'
const apiUrl = process.env.REACT_APP_API_URL;


async function getSumaryData(payload) {
    const result = await axios.post(apiUrl + "/admin/summary",payload,{
        headers: jsonHeader}
    );
    return result.data || [];
}

async function valanDates(payload) {
    const result = await axios.get(apiUrl + "/admin/get/valandates",payload,{
        headers: jsonHeader}
    );
    return result.data || [];
}
export const SummaryReportService = {
    getSumaryData,
    valanDates,
}